import { render, staticRenderFns } from "./DetailFooterButtons.vue?vue&type=template&id=cb6f9e20&scoped=true"
import script from "./DetailFooterButtons.vue?vue&type=script&lang=js"
export * from "./DetailFooterButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6f9e20",
  null
  
)

export default component.exports